import React from 'react';
import {
  Input, Form, Table, Card, Select,
} from 'antd';
import PropTypes from 'prop-types';
import { Text } from '../components/basic';
import { Flex } from '../components';
import Box from '../components/basic/Box';

const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);
class EditableCell extends React.Component {
  state = {
    editing: false,
  };

  toggleEdit = () => {
    const editing = !this.state.editing;
    this.setState({ editing }, () => {
      if (editing) {
        this.input.focus();
      }
    });
  };

  save = (e) => {
    const { record, handleSave } = this.props;
    this.form.validateFields((error, values) => {
      if (error && error[e.currentTarget.id]) {
        return;
      }
      this.toggleEdit();
      handleSave({ ...record, ...values });
    });
  };

  renderCell = (form) => {
    this.form = form;
    const {
      children, dataIndex, record, title, required, editable, register, type, values, defaultValue,
    } = this.props;
    const { editing } = this.state;

    let element = null;
    if (type === 'select') {
      element = (
        <Form.Item style={{ margin: 0, width: 'inherit', padding: 0 }}>
          {form.getFieldDecorator(dataIndex, {
            rules: [
              {
                required,
                message: `${title} es requerido.`,
              },
            ],
            initialValue: record[dataIndex] ? record[dataIndex] : defaultValue,
          })(
            <Select ref={(node) => { this.input = node; register(node); }} onSelect={this.save} onBlur={this.save}>
              {values && values.map(e => <Select.Option key={e.key}>{e.value}</Select.Option>)}
            </Select>,
          )}
        </Form.Item>
      );
    } else {
      element = (
        <Form.Item style={{ margin: 0, width: 'inherit' }}>
          {form.getFieldDecorator(dataIndex, {
            rules: [
              {
                required,
                message: `${title} es requerido.`,
              },
            ],
            initialValue: record[dataIndex],
          })(<Input style={{ width: 'inherit' }} ref={(node) => { this.input = node; register(node); }} onPressEnter={this.save} onBlur={this.save} />)}
        </Form.Item>
      );
    }

    return editing ? (
      element
    ) : (
      <div
        className={`editable-cell-value-wrap ${editable ? '' : 'disabled-cell'}`}
        style={{ marginTop: 5, marginBottom: 5 }}

      >
        {children}
      </div>
    );
  };

  render() {
    const {
      editable,
      disabled,
      dataIndex,
      title,
      record,
      index,
      handleSave,
      children,
      type,
      defaultValue,
      values,
      ...restProps
    } = this.props;
    return (
      <td {...restProps} style={{ padding: editable ? '0px 16px' : '16px', backgroundColor: disabled ? '#F5F5F5' : '', ...this.props.style }} onClick={() => (!editable || this.state.editing ? null : this.toggleEdit())}>
        {editable ? (
          <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
        ) : (
          children
        )}
      </td>
    );
  }
}

export default class EditableTable extends React.Component {
  onHandleSave = (row) => {
    const { onRowChange, dataSource } = this.props;
    onRowChange({ rowKey: row.key, newRow: row, dataSource });
  };

  render() {
    const {
      dataSource: unchangedDataSource, columns: initialColumns, rowSelection, onChange, total, pagination, loading, changedDataSource, bordered, basic, disableEdition, readOnly, register, size, ...otherProps
    } = this.props;
    const dataSource = unchangedDataSource ? unchangedDataSource.map((row) => {
      const changedRow = changedDataSource.find(e => e.id === row.id);
      const showedRow = changedRow || row;
      const showedRowCopy = { ...showedRow };
      initialColumns.forEach((e) => {
        if (e.defaultValue && (showedRowCopy[e.dataIndex] === undefined || showedRowCopy[e.dataIndex] === null || showedRowCopy[e.dataIndex] === false)) {
          showedRowCopy[e.dataIndex] = e.defaultValue;
        }
      });
      return showedRowCopy;
    }) : [];
    const components = {
      body: {
        row: EditableFormRow,
        cell: EditableCell,
      },
    };
    const columns = initialColumns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          editable: !disableEdition && col.editable && !readOnly,
          disabled: disableEdition && !readOnly,
          required: col.required,
          dataIndex: col.dataIndex,
          type: col.type ? col.type : null,
          defaultValue: col.defaultValue ? col.defaultValue : null,
          values: col.values ? col.values : null,
          title: col.title,
          handleSave: this.onHandleSave,
          register,
        }),
      };
    });
    if (basic) {
      return (
        <Box width="100%" {...otherProps}>
          <style>{'.ant-form-item-children{ width:100%}'}</style>
          <Table
            bordered={bordered}
            loading={loading}
            components={components}
            rowClassName={() => 'editable-row'}
            dataSource={dataSource}
            columns={columns}
            rowSelection={rowSelection}
            onChange={onChange}
            size={size}
            pagination={pagination ? { total, current: pagination.page, pageSize: pagination.pageSize } : false}
          />
        </Box>
      );
    }
    return (
      <Card
        bordered={false}
        title={(
          <div style={{ fontWeight: 'bold' }}>
            <Text color="#3E3E3C" fontWeight="bold" fontSize="16px" translationId="generico.resultados">Resultados</Text>
            <Text color="#3E3E3C" fontWeight="bold" fontSize="16px">
              {' '}
              (
              {total}
              )
            </Text>
          </div>
)}
      >
        <style>{'.ant-form-item-children{ width:100%}'}</style>
        <Table
          bordered={bordered}
          loading={loading}
          components={components}
          rowClassName={() => 'editable-row'}
          dataSource={dataSource}
          columns={columns}
          rowSelection={rowSelection}
          onChange={onChange}
          size={size}
          pagination={pagination ? { total, current: pagination.page, pageSize: pagination.pageSize } : false}
        />
      </Card>
    );
  }
}

EditableTable.propTypes = {
  pagination: PropTypes.oneOfType([PropTypes.shape({
    page: PropTypes.number, pageSize: PropTypes.number,
  }), PropTypes.bool]),
  dataSource: PropTypes.arrayOf(PropTypes.shape({})),
  changedDataSource: PropTypes.arrayOf(PropTypes.shape({})),
  columns: PropTypes.arrayOf(PropTypes.shape({})),
  rowSelection: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({})), PropTypes.bool]),
  total: PropTypes.number,
  onRowChange: PropTypes.func,
  register: PropTypes.func,
  onChange: PropTypes.func,
  loading: PropTypes.bool,
  bordered: PropTypes.bool,
  basic: PropTypes.bool,
  disableEdition: PropTypes.bool,
  readOnly: PropTypes.bool,
  size: PropTypes.string,
};
EditableTable.defaultProps = {
  dataSource: [],
  changedDataSource: [],
  loading: false,
  basic: false,
  readOnly: false,
  columns: [],
  rowSelection: [],
  onRowChange: () => {},
  onChange: () => {},
  register: () => {},
  total: null,
  pagination: { page: 1, pageSize: 8 },
  bordered: true,
  disableEdition: false,
  size: 'default',
};
